import { withRouter as withRouterNext } from 'next/router'
import hoistNonReactStatics from 'hoist-non-react-statics'

export default function withRouter(Component) {
  const RoutedComponent = withRouterNext(Component)
  hoistNonReactStatics(RoutedComponent, Component)
  return RoutedComponent
}
